<template>
    <div class="">
        <div class="clearfix">
            <div class="fleft">
                <router-link class="button is-info" :to="{name:'internetStarSourceEdit',query:{goodsSouceId:0}}">新增</router-link>
            </div>
            <el-pagination
                    v-if="count > 0"
                    @current-change="handleCurrentChange"
                    :current-page="search.page"
                    :page-size="search.pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="count"
                    class="fright">
            </el-pagination>
        </div>
        <div class="margin-top">
            <article class="tile is-child box">
                <table class="table is-bordered">
                    <thead>
                    <tr>
                        <td>商品源Id</td>
                        <td>店铺名称</td>
                        <td>店铺地址</td>
                        <td>关联ICON</td>
                        <td>操作</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in list">
                        <td>{{item.sourceId}}</td>
                        <td>{{item.shopName}}</td>
                        <td>{{item.shopLink}}</td>
                        <td>
                            <button class="button is-success margin-rb" v-for="bloggerItem in item.bloggers">{{bloggerItem.name}}</button>
                        </td>
                        <td>
                            <router-link class="button is-info" :to="{name:'internetStarSourceEdit',query:{sourceId:item.sourceId,page:search.page}}">编辑</router-link>
                            <button class="button is-danger" @click="deleteGoodsSource(index,item.sourceId)">删除</button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </article>
        </div>
        <div class="clearfix">
            <el-pagination
                    v-if="count > 0"
                    @current-change="handleCurrentChange"
                    :current-page="search.page"
                    :page-size="search.pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="count"
                    class="fright">
            </el-pagination>
        </div>
    </div>
</template>
<script type="text/babel">
    export default {
        data(){
            return {
                list:[],
                search:{
                    page:1,
                    pageSize:20
                },
                count:0,
            }
        },
        mounted(){
            if(this.$route.query.page){
                this.search.page=this.$route.query.page
            }
            this.getGoodsSourceList(this.search)
        },
        methods: {
            deleteGoodsSource(index,id){
                if(confirm("确定要删除吗")) {
                    HttpRequest.post("/admin.php?method=blogger.removeGoodsSource", {sourceId: id}, true).then((response) => {
                        if (response.data.success === 1) {
                            this.$message("删除成功");
                            this.list.splice(index,1)
                        }
                    });
                }
            },
            handleCurrentChange(value){
                if(this.search.page !== value){
                    this.search.page = value;
                    this.getGoodsSourceList(this.search)
                }
            },
            getGoodsSourceList(params){
                HttpRequest.post("/admin.php?method=blogger.getGoodsSourceList",params).then((response) => {
                    this.count=parseInt(response.data.count);
                    this.list = response.data.list;
                });
            }
        }
    }
</script>
<style lang="less">
    .category-img{
        height: 200px;
    }
    .margin-rb{
        margin-right: 5px;
        margin-bottom: 5px;
    }
</style>
